module.exports = " <div class=vc-popover v-show=show :style=\"{'top': pos.top + 'px', 'left': pos.left + 'px'}\" :class=\"{'vc-popover-top': pos.position === 'top', 'vc-popover-bottom': pos.position === 'bottom'}\" transition=vc-popover> <div class=vc-popover-content> <slot></slot> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/popover/popover.vue
 ** module id = 474
 ** module chunks = 1
 **/